// eslint-disable-next-line @altermaind/you-shall-not-pass
import { ContentType } from '@/swagger/constants/contents-orchestrator-enums';

export const MOCK_RESPONSE_GET_DASHBOARD_CONTENTS = {
  video: [
    {
      id: 'content_123',
      type: ContentType.VIDEO,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 0,
      views: 200,
      averageRating: 4.3,
      credits: 0,
      createdAt: '2026-01-09T08:08:25.079Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
  pdf: [
    {
      id: 'content_123',
      type: ContentType.PDF,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 0,
      views: 200,
      averageRating: 4.3,
      credits: 0,
      createdAt: '2026-01-09T08:08:25.079Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
  quiz: [
    {
      id: 'content_123',
      type: ContentType.QUIZ,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 10,
      views: 200,
      averageRating: 3.5,
      credits: 0,
      createdAt: '2026-01-09T08:08:25.079Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
};

export const MOCK_RESPONSE_GET_CONTENTS_BY_TYPE = {
  totalItems: 132,
  data: [
    {
      id: 'content_123',
      type: ContentType.VIDEO,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 0,
      views: 200,
      averageRating: 4.3,
      credits: 0,
      createdAt: '2026-01-09T08:31:06.476Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
};

export const MOCK_RESPONSE_GET_NEW_CONTENTS = {
  totalItems: 132,
  data: [
    {
      id: 'content_123',
      type: ContentType.VIDEO,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 0,
      views: 200,
      averageRating: 4.3,
      credits: 0,
      createdAt: '2026-01-09T15:55:18.928Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
};

export const MOCK_RESPONSE_GET_MY_CONTENTS = {
  totalItems: 132,
  data: [
    {
      id: 'content_123',
      type: ContentType.VIDEO,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 0,
      views: 200,
      averageRating: 4.3,
      credits: 0,
      createdAt: '2026-01-12T08:01:33.047Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
};

export const MOCK_RESPONSE_GET_CONTENTS_IN_PROGRESS = {
  totalItems: 1,
  data: [
    {
      id: 'content_123',
      type: ContentType.VIDEO,
      title: 'Presentazioni e materiali visivi',
      summary: "Come sfruttare l'AI per creare presentazioni...",
      tags: [
        {
          id: 'string',
          label: 'string',
        },
      ],
      thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
      durationMinutes: 15,
      questionsCount: 0,
      views: 200,
      averageRating: 4.3,
      credits: 0,
      createdAt: '2026-01-12T08:01:33.047Z',
      userDetails: {
        rating: 0,
        progress: {
          startedAt: '2025-11-10T09:00:00Z',
          completedAt: null,
        },
        favorite: true,
      },
    },
  ],
};

export const MOCK_RESPONSE_GET_TAGS = [
  {
    id: 'id-tag',
    label: 'tag',
  },
];

export const MOCK_RESPONSE_GET_CONTENT_DETAILS = {
  id: 'content_123',
  type: ContentType.VIDEO,
  title: 'Presentazioni e materiali visivi',
  summary: "Come sfruttare l'AI per creare presentazioni...",
  tags: [
    {
      id: 'string',
      label: 'string',
    },
  ],
  thumbnailUrl: 'https://cdn.example.com/thumbnails/content_123.jpg',
  durationMinutes: 15,
  questionsCount: 0,
  views: 200,
  averageRating: 4.3,
  credits: 0,
  createdAt: '2026-01-15T11:03:04.253Z',
  userDetails: {
    rating: 0,
    progress: {
      startedAt: '2025-11-10T09:00:00Z',
      completedAt: null,
    },
    favorite: true,
  },
  description: 'LONG DESCRIPTION TEXT',
  inner: {},
};

export const MOCK_RESPONSE_GET_CONTENT_START = {
  contentPath: 'string',
  progress: {
    type: 'VIDEO' as const,
    seconds: 15,
    durationSeconds: 80,
  },
};

export const MOCK_RESPONSE_POST_CONTENT_START = {
  contentPath: 'string',
  progress: {
    type: 'VIDEO' as const,
    seconds: 15,
    durationSeconds: 80,
  },
};

export const MOCK_RESPONSE_POST_CONTENT_PROGRESS = {
  startedAt: '2025-11-10T09:00:00Z',
  completedAt: null,
};

export const MOCK_RESPONSE_POST_CONTENT_END = {
  startedAt: '2025-11-10T09:00:00Z',
  completedAt: '2025-11-11T09:00:00Z',
};
